

import __layout_0 from '/usr/share/nginx/smartdoctors/front/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/components/Footer.vue'),
'components/NavBarI18n': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/components/NavBarI18n.vue'),
'components/NavBarNotifications': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/SearchNavBar': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/components/SearchNavBar.vue'),
'components/Settings': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/components/Settings.vue'),
'components/UserProfile': () => import('/usr/share/nginx/smartdoctors/front/src/layouts/components/UserProfile.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top) {
        // unplugin-vue-router adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)  

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          return { 
            path: route.path,
            component: layouts[route.meta?.layout || 'default'],
            children: route.path === '/' ? [route] : [{...route, path: ''}],
            meta: {
              isLayout: true
            }
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
